/**
 * Action Card Utilities
 * Reusable constants, styles, and functions for smart action cards in the rich editor
 */

// ============================================================================
// CONSTANTS
// ============================================================================

export const CARD_TYPES = {
  TASK: 'task',
  APPOINTMENT: 'appointment',
  ORDER: 'order',
  DOCUMENT: 'document',
  FORM: 'form',
};

export const TYPE_LABELS = {
  [CARD_TYPES.TASK]: 'Task',
  [CARD_TYPES.APPOINTMENT]: 'Appointment',
  [CARD_TYPES.ORDER]: 'Order',
  [CARD_TYPES.DOCUMENT]: 'Document',
  [CARD_TYPES.FORM]: 'Form',
};

export const STATUS_LABELS = {
  [CARD_TYPES.TASK]: 'Task Deleted',
  [CARD_TYPES.APPOINTMENT]: 'Appointment Cancelled',
  [CARD_TYPES.DOCUMENT]: 'Document Deleted',
};

// ============================================================================
// ICONS (SVG strings)
// ============================================================================

export const CARD_ICONS = {
  [CARD_TYPES.TASK]: `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6V12L16 14" stroke="#004879" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="9" stroke="#004879" stroke-width="2"/></svg>`,
  [CARD_TYPES.APPOINTMENT]: `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="4" width="18" height="18" rx="2" stroke="#004879" stroke-width="2"/><line x1="3" y1="9" x2="21" y2="9" stroke="#004879" stroke-width="2"/><line x1="9" y1="2" x2="9" y2="6" stroke="#004879" stroke-width="2" stroke-linecap="round"/><line x1="15" y1="2" x2="15" y2="6" stroke="#004879" stroke-width="2" stroke-linecap="round"/></svg>`,
  [CARD_TYPES.ORDER]: `<svg width="32" height="32" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 16.1914V4.82303C0 3.82414 0.790087 3.01439 1.76471 3.01439H2.54902C2.87389 3.01439 3.13725 3.28431 3.13725 3.61727C3.13725 3.95023 2.87389 4.22015 2.54902 4.22015H1.76471C1.43983 4.22015 1.17647 4.49007 1.17647 4.82303V16.1914C1.17647 16.5243 1.43983 16.7942 1.76471 16.7942H18.2353C18.5602 16.7942 18.8235 16.5243 18.8235 16.1914V4.82303C18.8235 4.49007 18.5602 4.22015 18.2353 4.22015H17.451C17.1261 4.22015 16.8627 3.95023 16.8627 3.61727C16.8627 3.28431 17.1261 3.01439 17.451 3.01439H18.2353C19.2099 3.01439 20 3.82415 20 4.82303V16.1914C20 17.1902 19.2099 18 18.2353 18H1.76471C0.790086 18 0 17.1902 0 16.1914Z" fill="#004879"/><path d="M9.60784 0V1.36652H8.98039V10.9322C8.98039 11.657 8.71597 12.3522 8.24529 12.8648C7.77461 13.3773 7.13623 13.6652 6.47059 13.6652C5.80495 13.6652 5.16657 13.3773 4.69589 12.8648C4.22521 12.3522 3.96078 11.657 3.96078 10.9322V1.36652H3.33333V0H9.60784ZM7.72549 5.4661H5.21569V10.9322C5.21569 11.2946 5.3479 11.6422 5.58324 11.8985C5.81858 12.1547 6.13777 12.2987 6.47059 12.2987C6.80341 12.2987 7.1226 12.1547 7.35794 11.8985C7.59328 11.6422 7.72549 11.2946 7.72549 10.9322V5.4661ZM7.09804 8.88241C7.26445 8.88241 7.42404 8.95439 7.54171 9.08253C7.65938 9.21067 7.72549 9.38446 7.72549 9.56567C7.72549 9.74688 7.65938 9.92067 7.54171 10.0488C7.42404 10.1769 7.26445 10.2489 7.09804 10.2489C6.93163 10.2489 6.77203 10.1769 6.65436 10.0488C6.5367 9.92067 6.47059 9.74688 6.47059 9.56567C6.47059 9.38446 6.5367 9.21067 6.65436 9.08253C6.77203 8.95439 6.93163 8.88241 7.09804 8.88241ZM5.84314 6.83262C6.00955 6.83262 6.16914 6.90461 6.28681 7.03274C6.40448 7.16088 6.47059 7.33467 6.47059 7.51588C6.47059 7.6971 6.40448 7.87089 6.28681 7.99902C6.16914 8.12716 6.00955 8.19915 5.84314 8.19915C5.67673 8.19915 5.51713 8.12716 5.39946 7.99902C5.28179 7.87089 5.21569 7.6971 5.21569 7.51588C5.21569 7.33467 5.28179 7.16088 5.39946 7.03274C5.51713 6.90461 5.67673 6.83262 5.84314 6.83262ZM7.72549 1.36652H5.21569V4.09957H7.72549V1.36652Z" fill="#004879"/><path d="M10.3922 0V1.36652H11.0196V10.9322C11.0196 11.657 11.284 12.3522 11.7547 12.8648C12.2254 13.3773 12.8638 13.6652 13.5294 13.6652C14.1951 13.6652 14.8334 13.3773 15.3041 12.8648C15.7748 12.3522 16.0392 11.657 16.0392 10.9322V1.36652H16.6667V0H10.3922ZM12.902 9.56567C12.5255 9.56567 12.2745 9.29237 12.2745 8.88241C12.2745 8.47245 12.5255 8.19915 12.902 8.19915C13.2784 8.19915 13.5294 8.47245 13.5294 8.88241C13.5294 9.29237 13.2784 9.56567 12.902 9.56567ZM14.1569 6.83262C13.7804 6.83262 13.5294 6.55932 13.5294 6.14936C13.5294 5.7394 13.7804 5.4661 14.1569 5.4661C14.5333 5.4661 14.7843 5.7394 14.7843 6.14936C14.7843 6.55932 14.5333 6.83262 14.1569 6.83262ZM14.7843 3.41631H12.2745V1.36652H14.7843V3.41631Z" fill="#004879"/></svg>`,
  [CARD_TYPES.DOCUMENT]: `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#004879" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><polyline points="14,2 14,8 20,8" stroke="#004879" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  [CARD_TYPES.FORM]: `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6V12L16 14" stroke="#004879" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="9" stroke="#004879" stroke-width="2"/></svg>`,
};

export const ACTION_ICONS = {
  edit: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2593 3C11.3558 3 11.4483 3.03665 11.5165 3.10188L13.5735 5.06948C13.7155 5.20531 13.7155 5.42554 13.5735 5.56138L6.88814 11.9561C6.84245 11.9998 6.78542 12.031 6.72291 12.0467L3.9386 12.7423C3.81369 12.7735 3.68085 12.7391 3.58957 12.6517C3.49828 12.5644 3.46224 12.4374 3.49487 12.3179L4.22214 9.65463C4.23847 9.59483 4.27116 9.54028 4.31684 9.49658L11.0022 3.10188C11.0704 3.03665 11.1629 3 11.2593 3Z" fill="#1e4670"/><path d="M3.54545 13.9565C3.24421 13.9565 3 14.1901 3 14.4783C3 14.7664 3.24421 15 3.54545 15H14.4545C14.7558 15 15 14.7664 15 14.4783C15 14.1901 14.7558 13.9565 14.4545 13.9565H3.54545Z" fill="#1e4670"/></svg>`,
  preview: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 3.75C5.25 3.75 2.0475 6.0825 0.75 9.375C2.0475 12.6675 5.25 15 9 15C12.75 15 15.9525 12.6675 17.25 9.375C15.9525 6.0825 12.75 3.75 9 3.75ZM9 13.125C6.93 13.125 5.25 11.445 5.25 9.375C5.25 7.305 6.93 5.625 9 5.625C11.07 5.625 12.75 7.305 12.75 9.375C12.75 11.445 11.07 13.125 9 13.125ZM9 7.125C7.755 7.125 6.75 8.13 6.75 9.375C6.75 10.62 7.755 11.625 9 11.625C10.245 11.625 11.25 10.62 11.25 9.375C11.25 8.13 10.245 7.125 9 7.125Z" fill="#1e4670"/></svg>`,
  cancel: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 6H2.25V7.5H10.5V6ZM10.5 3H2.25V4.5H10.5V3ZM2.25 10.5H7.5V9H2.25V10.5ZM10.8075 15L12.75 13.0575L14.6925 15L15.75 13.9425L13.8075 12L15.75 10.0575L14.6925 9L12.75 10.9425L10.8075 9L9.75 10.0575L11.6925 12L9.75 13.9425L10.8075 15Z" fill="#1e4670"/></svg>`,
  close: `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L13 13M1 13L13 1" stroke="#999" stroke-width="2" stroke-linecap="round"/></svg>`,
};

// ============================================================================
// STYLES
// ============================================================================

export const CARD_STYLES = {
  wrapper: 'margin: 12px 0; user-select: none; max-width: 760px;',
  bubble: 'background-color: #f9fbfd; border: 1px solid #c4c4c4; border-radius: 20px; padding: 12px 24px;',
  bubbleDeleted: 'background-color: rgba(250, 234, 234, 0.5); border: 1px solid rgba(209, 0, 0, 0.5); border-radius: 20px; padding: 12px 24px; position: relative;',
  content: 'display: flex; flex-direction: column; gap: 4px;',
  header: 'display: flex; gap: 8px; align-items: center;',
  icon: 'width: 64px; height: 64px; background: #f2f2f2; border-radius: 8px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;',
  title: "flex: 1; font-weight: 500; font-size: 16px; line-height: 20px; color: #374957; padding-top: 4px;",
  titleDeleted: "flex: 1; font-weight: 500; font-size: 16px; line-height: 20px; color: #374957; padding-top: 4px; display: flex; flex-direction: column; align-items: flex-start; gap: 4px;",
  description: "font-size: 10px; line-height: 16px; color: #333333; padding: 4px 0",
  actions: 'display: flex; gap: 10px; justify-content: flex-end; padding: 4px 0; padding-left: 72px; border-top: 1px dashed #c4c4c4;',
  actionBtn: "display: flex; align-items: center; gap: 4px; font-weight: 500; font-size: 14px; color: #1e4670; text-decoration: underline; cursor: pointer; padding: 4px 10px;",
  closeBtn: 'cursor: pointer; display: flex; align-items: center; justify-content: center; width: 24px; height: 24px;',
  statusBadge: "display: inline-flex; align-items: center; justify-content: center; background-color: #faeaea; border-radius: 20px; padding: 4px 8px;",
  statusBadgeText: "font-weight: 500; font-size: 10px; color: #d10000; line-height: 12px;",
  orderStatusSection: 'width: 100%; padding: 8px 0 8px 72px; display: flex; align-items: center; justify-content: center;',
  orderStatusBadge: "display: inline-flex; align-items: center; justify-content: center; padding: 4px 48px; border-radius: 20px;",
  orderStatusText: "font-weight: 400; font-size: 14px; line-height: 20px; letter-spacing: 0.25px; text-align: center;",
  // Form card styles (matching chat task card)
  formTitle: "flex: 1; display: flex; flex-direction: column; gap: 4px;",
  formTitleText: "font-weight: 500; font-size: 16px; line-height: 20px; color: #374957; letter-spacing: 0.1px;",
  formDueDate: "font-weight: 400; font-size: 12px; line-height: 16px; letter-spacing: 0.4px; color: #666666;",
  formStatusBadge: "display: inline-flex; align-items: center; justify-content: center; padding: 4px 8px; border-radius: 20px; align-self: flex-start;",
  formStatusText: "font-weight: 500; font-size: 10px; line-height: 12px; letter-spacing: 0.25px;",
  formDescription: "width: 100%; padding: 8px 0 8px 72px; font-weight: 400; font-size: 12px; line-height: 20px; letter-spacing: 0.25px; color: #333;",
};

// ============================================================================
// DOCUMENT DESCRIPTION HELPERS
// ============================================================================

/**
 * Format file size from bytes to human-readable string
 */
export const formatDocumentFileSize = (bytes) => {
  if (!bytes || bytes === 0) return '';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + sizes[i];
};

/**
 * Map content type to short file type label
 */
export const formatDocumentFileType = (contentType) => {
  if (!contentType) return 'File';
  if (contentType === 'application/pdf') return 'PDF';
  if (contentType.startsWith('image/')) return 'Image';
  if (contentType.includes('word')) return 'DOC';
  if (contentType.includes('sheet') || contentType.includes('csv')) return 'Spreadsheet';
  return 'File';
};

/**
 * Build a description string for a document card from metadata.
 * Accepts either camelCase or snake_case field names.
 * @param {object} doc - Document metadata (createdAt, contentType, fileSize)
 * @returns {string}
 */
export const formatDocumentCardDescription = (doc) => {
  const parts = [];
  const createdAt = doc.createdAt || doc.created_at;
  if (createdAt) {
    const date = new Date(createdAt);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    parts.push(`Created On: ${mm}-${dd}-${yyyy}`);
  }
  const fileType = formatDocumentFileType(doc.contentType || doc.content_type);
  const fileSize = formatDocumentFileSize(doc.fileSize || doc.file_size);
  if (fileType || fileSize) parts.push(`${fileType} ${fileSize}`.trim());
  return parts.join(' | ') || 'No description provided.';
};

// ============================================================================
// ENCODING/DECODING FUNCTIONS
// ============================================================================

/**
 * Encode card data into a class name (backend-safe, survives HTML sanitization)
 */
export const encodeCardClass = (type, id, title, description, calendarId = null, extra = null) => {
  const data = JSON.stringify({ type, id, title, description, calendarId, ...extra });
  const encoded = btoa(unescape(encodeURIComponent(data)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
  return `card-action-data-${encoded}`;
};

/**
 * Decode card data from class name
 */
export const decodeCardClass = (className) => {
  const match = className.match(/card-action-data-([A-Za-z0-9_-]+)/);
  if (!match) return null;
  try {
    let encoded = match[1].replace(/-/g, '+').replace(/_/g, '/');
    while (encoded.length % 4) encoded += '=';
    const decoded = decodeURIComponent(escape(atob(encoded)));
    return JSON.parse(decoded);
  } catch (e) {
    console.error('Failed to decode card data:', e);
    return null;
  }
};

// ============================================================================
// HTML GENERATION FUNCTIONS
// ============================================================================

/**
 * Generate action buttons HTML for a card
 */
export const generateActionButtons = (type, id, calendarId = null) => {
  const btnStyle = CARD_STYLES.actionBtn;

  if (type === CARD_TYPES.TASK) {
    return `
      <span class="card-action-btn card-action-btn-edit" data-action="edit" data-type="task" data-id="${id}" style="${btnStyle}">${ACTION_ICONS.edit}<span style="text-decoration: underline;">Edit</span></span>
      <span class="card-action-btn card-action-btn-delete" data-action="delete" data-type="task" data-id="${id}" style="${btnStyle}">${ACTION_ICONS.cancel}<span style="text-decoration: underline;">Delete Task</span></span>
    `;
  }

  if (type === CARD_TYPES.APPOINTMENT) {
    return `
      <span class="card-action-btn card-action-btn-edit" data-action="edit" data-type="appointment" data-id="${id}" data-calendar-id="${calendarId}" style="${btnStyle}">${ACTION_ICONS.edit}<span style="text-decoration: underline;">Edit</span></span>
      <span class="card-action-btn card-action-btn-cancel" data-action="cancel" data-type="appointment" data-id="${id}" data-calendar-id="${calendarId}" style="${btnStyle}">${ACTION_ICONS.cancel}<span style="text-decoration: underline;">Cancel Appointment</span></span>
    `;
  }

  if (type === CARD_TYPES.DOCUMENT) {
    return `
      <span class="card-action-btn card-action-btn-preview" data-action="preview" data-type="document" data-id="${id}" style="${btnStyle}">${ACTION_ICONS.preview}<span style="text-decoration: underline;">Preview</span></span>
      <span class="card-action-btn card-action-btn-delete" data-action="delete" data-type="document" data-id="${id}" style="${btnStyle}">${ACTION_ICONS.cancel}<span style="text-decoration: underline;">Delete Document</span></span>
    `;
  }

  if (type === CARD_TYPES.ORDER) {
    return `
      <span class="card-action-btn card-action-btn-details" data-action="details" data-type="order" data-id="${id}" style="${btnStyle}">${ACTION_ICONS.preview}<span style="text-decoration: underline;">See Details</span></span>
    `;
  }

  if (type === CARD_TYPES.FORM) {
    return `
      <span class="card-action-btn card-action-btn-details" data-action="details" data-type="form" data-id="${id}" style="${btnStyle}">${ACTION_ICONS.preview}<span style="text-decoration: underline;">See Details</span></span>
    `;
  }

  // Default to task buttons
  return generateActionButtons(CARD_TYPES.TASK, id);
};

/**
 * Generate order status badge HTML
 * @param {string} statusText - Display text for the status
 * @param {string} color - Text color
 * @param {string} bgColor - Background color
 */
export const generateOrderStatusHTML = (statusText, color, bgColor) => {
  return `
    <div class="card-action-order-status" style="${CARD_STYLES.orderStatusSection}">
      <div style="${CARD_STYLES.orderStatusBadge} color: ${color}; background-color: ${bgColor};">
        <span style="${CARD_STYLES.orderStatusText}">${statusText}</span>
      </div>
    </div>
  `;
};

/**
 * Generate form card HTML (matches the chat task card layout)
 * @param {string} title - Form title
 * @param {string} dueDate - Due date string (ISO or formatted)
 * @param {boolean} isCompleted - Whether the form is completed
 * @param {string} description - Description text
 * @param {string} iconSvg - Icon SVG string
 * @param {string} actionButtons - Action buttons HTML
 */
export const generateFormCardHTML = (title, dueDate, isCompleted, description, iconSvg, actionButtons) => {
  const formattedDue = dueDate ? formatFormDueDate(dueDate) : '';
  const dueDateHTML = formattedDue ? `<div style="${CARD_STYLES.formDueDate}">Due by: ${formattedDue}</div>` : '';

  const statusColor = isCompleted ? '#25B8C2' : '#d10000';
  const statusBg = isCompleted ? '#ebfff8' : '#faeaea';
  const statusLabel = isCompleted ? 'Completed' : 'Unfinished';
  const statusBadgeHTML = `
    <div class="card-action-form-status" style="${CARD_STYLES.formStatusBadge} color: ${statusColor}; background-color: ${statusBg};">
      <span style="${CARD_STYLES.formStatusText}">${statusLabel}</span>
    </div>
  `;

  const actionsSection = actionButtons ? `
    <div class="card-action-actions" style="${CARD_STYLES.actions}">
      ${actionButtons}
    </div>
  ` : '';

  return `
    <div class="card-action-bubble" style="${CARD_STYLES.bubble}">
      <div class="card-action-content" style="${CARD_STYLES.content}">
        <div class="card-action-header" style="${CARD_STYLES.header}">
          <div class="card-action-icon" style="${CARD_STYLES.icon}">
            ${iconSvg}
          </div>
          <div class="card-action-title" style="${CARD_STYLES.formTitle}">
            <div style="${CARD_STYLES.formTitleText}">${title}</div>
            ${dueDateHTML}
            ${statusBadgeHTML}
          </div>
        </div>
        <div class="card-action-description" style="${CARD_STYLES.formDescription}">
          ${description}
        </div>
        ${actionsSection}
      </div>
    </div>
  `;
};

/**
 * Format a due date for form card display (MM-DD-YYYY)
 */
const formatFormDueDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${mm}-${dd}-${yyyy}`;
};

/**
 * Generate full card HTML
 * @param {string} type
 * @param {string} title
 * @param {string} description
 * @param {string} iconSvg
 * @param {string} actionButtons
 * @param {object} [options]
 * @param {string} [options.orderStatusHTML] - Pre-built order status badge HTML
 */
export const generateCardHTML = (type, title, description, iconSvg, actionButtons, options = {}) => {
  const typeLabel = TYPE_LABELS[type] || type;

  // Only include actions section if there are action buttons
  const actionsSection = actionButtons ? `
    <div class="card-action-actions" style="${CARD_STYLES.actions}">
      ${actionButtons}
    </div>
  ` : '';

  const orderStatusSection = options.orderStatusHTML || '';

  return `
    <div class="card-action-bubble" style="${CARD_STYLES.bubble}">
      <div class="card-action-content" style="${CARD_STYLES.content}">
        <div class="card-action-header" style="${CARD_STYLES.header}">
          <div class="card-action-icon" style="${CARD_STYLES.icon}">
            ${iconSvg}
          </div>
          <div class="card-action-title" style="${CARD_STYLES.title}">
            ${typeLabel}: ${title}
          </div>
        </div>
        <div class="card-action-description" style="${CARD_STYLES.description}">
          ${description}
        </div>
        ${orderStatusSection}
        ${actionsSection}
      </div>
    </div>
  `;
};

/**
 * Generate status badge HTML
 */
export const generateStatusBadge = (type) => {
  const label = STATUS_LABELS[type] || 'Cancelled';
  return `<span style="${CARD_STYLES.statusBadgeText}">${label}</span>`;
};

// ============================================================================
// DOM MANIPULATION FUNCTIONS
// ============================================================================

/**
 * Apply deleted/cancelled styling to a card wrapper element
 */
export const applyDeletedStyling = (wrapper, type, onClose, isDraft = true) => {
  // Update bubble styling
  const bubble = wrapper.querySelector('.card-action-bubble');
  if (bubble) {
    bubble.style.backgroundColor = 'rgba(250, 234, 234, 0.5)';
    bubble.style.borderColor = 'rgba(209, 0, 0, 0.5)';
    bubble.style.position = 'relative';
  }

  // Add close button to header (only in draft mode)
  if (isDraft) {
    const headerEl = wrapper.querySelector('.card-action-header');
    if (headerEl && !wrapper.querySelector('.card-action-close')) {
      const closeBtn = document.createElement('div');
      closeBtn.className = 'card-action-close';
      closeBtn.style.cssText = CARD_STYLES.closeBtn;
      closeBtn.innerHTML = ACTION_ICONS.close;
      closeBtn.onclick = (e) => {
        e.stopPropagation();
        if (onClose) onClose();
      };
      headerEl.appendChild(closeBtn);
    }
  }

  // Add status badge below title
  const titleEl = wrapper.querySelector('.card-action-title');
  if (titleEl && !wrapper.querySelector('.card-action-status-badge')) {
    // Make title a flex column
    titleEl.style.display = 'flex';
    titleEl.style.flexDirection = 'column';
    titleEl.style.alignItems = 'flex-start';
    titleEl.style.gap = '4px';

    // Wrap existing title text
    if (!titleEl.querySelector('span')) {
      const titleText = titleEl.textContent;
      titleEl.innerHTML = `<span>${titleText}</span>`;
    }

    // Create and add badge
    const badge = document.createElement('div');
    badge.className = 'card-action-status-badge';
    badge.style.cssText = CARD_STYLES.statusBadge;
    badge.innerHTML = generateStatusBadge(type);
    titleEl.appendChild(badge);
  }

  // Remove action buttons
  const actionsEl = wrapper.querySelector('.card-action-actions');
  if (actionsEl) {
    actionsEl.remove();
  }
};

/**
 * Find a card wrapper by type and id in the editor
 */
export const findCardWrapper = (editorSelector, type, id) => {
  const editorElement = document.querySelector(editorSelector);
  if (!editorElement) return null;

  const cardWrappers = editorElement.querySelectorAll('.card-action-wrapper');
  for (const wrapper of cardWrappers) {
    const decoded = decodeCardClass(wrapper.className);
    if (decoded && decoded.type === type && String(decoded.id) === String(id)) {
      return wrapper;
    }
  }
  return null;
};

/**
 * Mark a card as deleted/cancelled
 */
export const markCardAsDeleted = (editorSelector, type, id, onClose, isDraft = true) => {
  const wrapper = findCardWrapper(editorSelector, type, id);
  if (wrapper) {
    applyDeletedStyling(wrapper, type, onClose, isDraft);
    return true;
  }
  return false;
};

// ============================================================================
// PREVIEW TEXT GENERATION
// ============================================================================

/**
 * Build inline text string from the API's structured inline_text response.
 * The API returns { inline_text: { title, body: [...] } } where body items are
 * either { text: "..." } for static text or { key: "...", placeholder: "..." } for dynamic values.
 * Dynamic keys are filled from the card's encoded data.
 * @param {object} inlineData - API response for a card type
 * @param {object} cardData - Decoded card data { type, id, title, description, calendarId }
 * @returns {string} - Built inline text string
 */
const buildInlineText = (inlineData, cardData) => {
  const inlineText = inlineData?.inline_text;

  // If inline_text is a plain string, use it directly
  if (typeof inlineText === 'string') return inlineText;

  // If inline_text is structured with a body array, build the string
  if (inlineText && Array.isArray(inlineText.body)) {
    return inlineText.body.map((part) => {
      if (part.text !== undefined) return part.text;
      if (part.key) {
        // Map API keys to card data fields
        const value = getCardValueForKey(part.key, cardData);
        return value || part.placeholder || '___';
      }
      return '';
    }).join('');
  }

  // Fallback to other possible fields
  return inlineData?.text || inlineData?.template || `[${TYPE_LABELS[cardData?.type] || cardData?.type || 'Card'}]`;
};

/**
 * Map an inline text key to a value from the card's encoded data.
 * @param {string} key - The key from the API body (e.g., "subject", "time", "assignee", "status")
 * @param {object} cardData - Decoded card data
 * @returns {string|null}
 */
const getCardValueForKey = (key, cardData) => {
  if (!cardData) return null;

  switch (key) {
    case 'subject':
      return cardData.title || null;
    case 'time':
    case 'assignee':
    case 'status':
      // These values are embedded in the description string if available
      // Try to extract from description, e.g., "Follow-up, 30 min | Appointment Time: 09:30, 02-06-2026"
      return extractFromDescription(key, cardData.description) || null;
    default:
      return null;
  }
};

/**
 * Extract a specific field value from a card's description string.
 * Description format examples:
 *   "Follow-up, 30 min | Appointment Time: 09:30, 02-06-2026"
 *   "Created On: 02-06-2026 | PDF 612KB"
 */
const extractFromDescription = (key, description) => {
  if (!description) return null;

  if (key === 'time') {
    // Try to extract time from "Appointment Time: HH:MM, MM-DD-YYYY"
    const timeMatch = description.match(/Appointment Time:\s*(.+)/i);
    if (timeMatch) return timeMatch[1].trim();
    // Fallback: return full description as it likely contains time info
    return description;
  }

  // For assignee and status, these aren't typically in the encoded card description
  return null;
};

/**
 * Replace action card HTML elements with inline text, preserving the rest of the HTML.
 * Used for rendering note content where cards should show as text but other HTML stays intact.
 * @param {string} contentHtml - The note's HTML content
 * @param {object} inlineTextMap - Map of card type → inline text data from API
 * @returns {string} - HTML with card elements replaced by inline text spans
 */
export const replaceCardsWithInlineHtml = (contentHtml, inlineTextMap = {}) => {
  if (!contentHtml) return '';
  if (!/card-action-data-/.test(contentHtml)) return contentHtml;

  const parser = new DOMParser();
  const doc = parser.parseFromString(contentHtml, 'text/html');

  const allElements = doc.querySelectorAll('[class*="card-action-data-"]');
  for (const el of allElements) {
    const decoded = decodeCardClass(el.className);
    if (decoded && decoded.type && inlineTextMap[decoded.type]) {
      const inlineData = inlineTextMap[decoded.type];
      const text = buildInlineText(inlineData, decoded);
      const span = doc.createElement('span');
      span.textContent = text;
      el.replaceWith(span);
    } else {
      const typeLabel = decoded ? (TYPE_LABELS[decoded.type] || decoded.type) : 'Card';
      const span = doc.createElement('span');
      span.textContent = `[${typeLabel}]`;
      el.replaceWith(span);
    }
  }

  return doc.body.innerHTML;
};

/**
 * Generate a plain-text preview for a note, replacing action cards with inline text.
 * @param {string} contentHtml - The note's HTML content
 * @param {string} contentText - The note's existing plain text (fallback)
 * @param {string} title - The note's title (fallback)
 * @param {object} inlineTextMap - Map of card type → inline text data from API
 * @returns {string} - Preview text for display in the notes list
 */
export const generateNotePreview = (contentHtml, contentText, title, inlineTextMap = {}) => {
  if (!contentHtml) return contentText || title || '';

  // Helper to strip HTML tags and get plain text
  const stripHtml = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
  };

  // Check if content contains any action cards
  const hasCards = /card-action-data-/.test(contentHtml);
  if (!hasCards) return contentText || stripHtml(contentHtml) || title || '';

  // If no inline text data available (API error), fall back to original content
  if (!inlineTextMap || Object.keys(inlineTextMap).length === 0) {
    return contentText || stripHtml(contentHtml) || title || '';
  }

  // Parse HTML and replace card nodes with inline text
  const parser = new DOMParser();
  const doc = parser.parseFromString(contentHtml, 'text/html');

  // Find all card wrapper elements by class pattern
  const allElements = doc.querySelectorAll('[class*="card-action-data-"]');
  for (const el of allElements) {
    const decoded = decodeCardClass(el.className);
    if (decoded && decoded.type && inlineTextMap[decoded.type]) {
      const inlineData = inlineTextMap[decoded.type];
      const text = buildInlineText(inlineData, decoded);
      const textNode = doc.createTextNode(text + ' ');
      el.replaceWith(textNode);
    } else {
      // No inline text available — use type label as fallback
      const typeLabel = decoded ? (TYPE_LABELS[decoded.type] || decoded.type) : 'Card';
      el.replaceWith(doc.createTextNode(`[${typeLabel}] `));
    }
  }

  // Extract plain text from the modified HTML
  const preview = (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
  return preview || contentText || title || '';
};
